interface Props {
  title: string,
  value: string | number,
  icon: React.ElementType;
  colorClass: {
    bg: string,
    text: string,
    bgHover: string
  },
  linkText: string;
  onClick: () => void
}

function StatCardString({ title, value, icon: Icon, colorClass, linkText, onClick }: Props) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 relative overflow-hidden h-36 border border-gray-900/15">
      <div className="flex items-center space-x-4">
        <div className={`p-3 rounded-full ${colorClass.bg} ${colorClass.text}`}>
          <Icon size={28} />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className="text-3xl font-bold text-gray-900">{value}</p>
        </div>
      </div>
      <div
        className={`absolute bottom-0 left-0 right-0 p-2 text-xs font-medium text-center cursor-pointer ${colorClass.text} ${colorClass.bgHover} hover:opacity-90 transition-all`}
        onClick={onClick}>
        {linkText} &rarr;
      </div>
    </div>
  );
};

export default StatCardString;